module.exports = __webpack_public_path__ + "static/media/aav-ewhite-logo.0f7881fc.svg";